import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "cloud1",
  width: "100%",
  height: "100%",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "cloud_a1",
    patternUnits: "userSpaceOnUse",
    width: "197",
    height: "130",
    patternTransform: "scale(0.2) rotate(0)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      fill: "transparent"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.000155851 58.0576C0.000103901 58.0575 5.19504e-05 58.0575 0 58.0574V58.056C5.19453e-05 58.0566 0.000103896 58.0571 0.000155851 58.0576ZM0.000155851 58.0576C3.17738 89.5364 25.9583 120.665 51.6532 109.416C55.6586 137.166 93.912 134.376 103.466 113.843C109.004 138.674 156.334 128.878 157.186 102.717C214.92 110.297 205.41 10.5915 157.186 24.2037C153.424 -8.0449 99.3552 -6.62541 93.6124 19.9125C72.1062 9.73655 50.1067 33.4707 57.4863 53.0461C45.3251 49.0109 39.4896 56.0359 34.51 62.0306C32.9506 63.9079 31.4751 65.6842 29.9156 66.9881C23.3767 72.4554 9.90709 69.8966 0.000155851 58.0576ZM107.546 8.17312C112.778 5.21399 119.576 3.64492 126.298 3.80902L126.298 3.8089C133.021 3.9731 139.593 5.82307 144.521 9.27593C149.449 12.7288 152.861 17.5996 153.681 24.622C153.936 26.774 156.336 28.3981 158.429 27.8351C169.29 24.7694 177.143 27.8937 183.126 34.3572C189.11 40.8209 192.835 51.0172 193.389 61.4046C193.943 71.7924 191.334 82.2421 185.62 89.3636C179.907 96.4851 171.286 100.712 157.902 98.9549C127.723 91.0532 148.184 58.0963 164.127 68.4392L165.005 64.4959C144.409 52.7009 122.323 88.8346 153.634 102.551C153.458 107.958 150.967 112.501 146.92 116.171C142.873 119.84 137.279 122.47 131.574 123.652C125.87 124.833 120.067 124.528 115.749 122.741C111.431 120.953 108.528 118.043 107.405 113.005C107.066 111.466 105.675 110.219 104.108 110.051C102.541 109.883 100.917 110.806 100.259 112.238C96.2709 120.809 85.7106 126.13 75.8008 125.954C70.8458 125.865 66.1555 124.419 62.6127 121.686C59.0699 118.952 57.0838 114.849 55.6111 108.881C50.2031 86.9704 77.7233 78.6105 80.8185 100.113L85.1982 99.8162C82.0953 71.949 46.8484 82.9828 50.3351 105.956C39.0404 110.9 29.023 106.774 20.4103 97.2278C13.8311 89.9353 8.65539 79.4343 5.87945 68.2145C9.01771 70.3123 12.2602 71.8262 15.4707 72.6744C21.7592 74.3361 28.116 73.6342 32.5908 69.893C34.7456 68.0913 36.5218 65.9396 38.2211 63.881C39.754 62.0241 41.2243 60.2429 42.8534 58.863C46.2886 55.9533 49.579 54.3532 56.5209 56.657C57.8729 57.1106 59.4703 56.7185 60.4585 55.6903C61.4468 54.6623 61.7754 53.0505 61.2686 51.7175C55.1209 35.4131 73.6559 14.5529 92.2001 23.3273C82.0962 70.5477 146.702 61.8818 131.28 25.9L126.583 28.4591C139.151 56.0858 85.2009 64.9405 97.5235 20.7377C98.7 15.3006 102.315 11.1321 107.546 8.17312Z",
      fill: "transparent",
      "stroke-width": "1",
      stroke: "currentColor"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "800%",
  height: "800%",
  transform: "translate(0,0)",
  fill: "url(#cloud_a1)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }